import { sortAlphabetically } from './arrayUtils';

export const dataToTree = treeNode => {
    const { groups, clauses } = treeNode;
    return {
        ...treeNode,
        count: clauses ? clauses.length : 0,
        children: groups ? sortAlphabetically(groups, 'name').map(group => dataToTree(group)) : []
    };
};

export const sortClauses = clauses => {
    return sortAlphabetically(clauses, 'name').map(treeNode => dataToTree(treeNode));
};

export const countClauses = (acc, clause) => {
    acc += clause.clauses ? clause.clauses.length : 0;
    if (Array.isArray(clause.groups)) {
        return clause.groups.reduce(countClauses, acc);
    }
    return acc;
};
